import {Navigate,useLocation} from 'react-router-dom';


export const AuthRoute = ({children})=>{
    const isAuthenticated = checkJWTToken();
    return isAuthenticated ? <Navigate to="/main" replace /> : children;
}
export const PrivateRoute = ({children})=>{
    const isAuthenticated = checkJWTToken();
    const location = useLocation();
    return isAuthenticated ? children : <Navigate to="/" state={{from:location.pathname + location.search}} replace />;
}

const checkJWTToken = () =>{
    const cookies = document.cookie;
    if(cookies.includes('jwtuser=')){
        return true;
    } else {
        return false;
    }
}